const NotamachineCollabsStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static">  

        <div class="gallery_item">
            <p class="gallery-tag">Collab</p>
            <a href="https://open.spotify.com/track/206S6JSiu82uJHrFUlPgHO?si=397f3d9f5f524900" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b2736b1fa672ff7d77495b694bad" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Last Will - Family Matters</strong><br/>
                (prod. Last Will & notamachine)
              </p>
            </a>
          </div>

          
          <div class="gallery_item">
            <p class="gallery-tag">Collab</p>
            <a href="https://open.spotify.com/track/3cUbZmRD205pJvIdn7fGcX?si=222584c9c52f4e29" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27304e7f11ab00e950401059eab" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>skybourneDee - Lifeline</strong><br/>
                (prod. skybourneDee & notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Collab</p>
            <a href="https://open.spotify.com/track/6O4i75QqIZOitULXFeiQgg?si=c077ebfbf5674223" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27304e7f11ab00e950401059eab" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>skybourneDee - Foreign Whip</strong><br/>
                (prod. skybourneDee & notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Collab</p>
            <a href="https://open.spotify.com/track/4RmGpbpP7VEzUZ901b0QPm?si=2541d47be226423a" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27304e7f11ab00e950401059eab" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>skybourneDee - Alone Together</strong><br/>
                (prod. skybourneDee & notamachine)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Collab</p>
            <a href="https://open.spotify.com/track/3VWsK5vxZu7qWI56oyxy7M?si=49da0f56356c4c36" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b27304e7f11ab00e950401059eab" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>skybourneDee - The Mood</strong><br/>
                (prod. skybourneDee & notamachine)
              </p>
            </a>
          </div>  

          <div class="gallery_item">
            <p class="gallery-tag">Collab</p>
            <a href="https://open.spotify.com/track/0DEtUjmC4m82B27gCNiuYy?si=a103eb0557784c9c" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-WTUSGCOp2VPFpQnM-31pPfA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Last Will - Slow Down</strong><br/>
                (prod. Last Will & notamachine)
              </p>
            </a>
          </div>

        </div>
      </>
    );
  };
  export default NotamachineCollabsStatic;